import { SET_STATS, RESET_STATE } from "@/store/mutation-types";
import CacheService from "@/services/CacheService";
import { RequestMethod } from "@/types/request-method";
import { StatsState, Stats } from "@/types/stats";
import { RootState } from "@/types/root-state";
import * as Msg from "@/config/notification";
import { setNotificationError } from "@/utils/notification";
import { Module, MutationTree, ActionTree, GetterTree } from "vuex";
import { StatsInitialState } from "@/store/state";

const namespaced = true;

const state: StatsState = {
  stats: new StatsInitialState(),
};

const mutations: MutationTree<StatsState> = {
  [SET_STATS]: (state, stats: Stats) => {
    state.stats = stats;
  },
  [RESET_STATE]: state => {
    Object.assign(state, {
      stats: new StatsInitialState(),
    });
  },
};

const actions: ActionTree<StatsState, RootState> = {
  fetch({ commit, dispatch, rootState }) {
    const cacheID = rootState.activeCacheID;
    return CacheService.request(`caches/${cacheID}/stats`, RequestMethod.GET)
      .then(response => {
        const stats: Stats = response.data;
        commit(SET_STATS, stats);
      })
      .catch(error => {
        setNotificationError(dispatch, `${Msg.STATS_ERROR} (${error})`);
      });
  },
  resetState({ commit }) {
    commit(RESET_STATE);
  },
};

const getters: GetterTree<StatsState, RootState> = {
  allTimeHitRate: state => {
    const types = ["get", "delete", "incr", "decr", "cas", "touch"];

    let hits = 0;
    for (const type of types) {
      hits += state.stats[`${type}_hits`];
    }

    let misses = 0;
    for (const type of types) {
      misses += state.stats[`${type}_misses`];
    }

    const requests = hits + misses;

    if (requests === 0) {
      return 0;
    }

    return hits / requests;
  },
};

export const stats: Module<StatsState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
